// src/hooks/useDeclinedDailyClockNotifications.js
import { useState, useEffect } from 'react';
import api from '../utils/api';
import { useSocket } from '../components/context/SocketProvider';
import { useAuth } from '../components/context/AuthContext';

export const useDeclinedDailyClockNotifications = () => {
    const [hasDeclinedDailyClock, setHasDeclinedDailyClock] = useState(false);
    const socket = useSocket();
    const { user, loading } = useAuth();

    useEffect(() => {
        // ⭐ FIX: wait for the real session, not just the cached profile.
        // AuthContext hydrates `user` IMMEDIATELY from a cached localStorage
        // profile on page load, before the real __session cookie exists —
        // the login round trip is still in flight. Firing this fetch against
        // that cached-but-not-yet-authenticated state got a 403 every time
        // (harmless — it retries once the real session settles and `user`
        // updates again — but noisy). `loading` only goes false once auth
        // has genuinely resolved.
        if (loading) return;
        // Only fetch if the user is logged in and is an admin or manager
        if (!user || (user.role !== 'admin' && user.role !== 'manager')) return;

        const fetchDeclinedCount = async () => {
            try {
                const res = await api.get('/staff/daily-clock/declined-items');
                setHasDeclinedDailyClock((res.data?.totalDeclined || 0) > 0);
            } catch (error) {
                console.error('Failed to fetch declined daily-clock count for sidebar:', error);
            }
        };

        fetchDeclinedCount();

        // Listen for real-time updates
        if (socket) {
            const handleUpdate = () => {
                fetchDeclinedCount();
            };

            // Fired both when a new decline comes in, and when one gets corrected
            socket.on('declined-daily-clock-update', handleUpdate);

            return () => {
                socket.off('declined-daily-clock-update', handleUpdate);
            };
        }
    }, [socket, user, loading]);

    return { hasDeclinedDailyClock };
};